import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashRegister, CashRegisterState } from "../../../types/cash/cashRegister";


const initialFormState: CashRegister = {
    id: null,
    name: "",
    code: "",
    branchId: null,
    active: true
};

const initialState: CashRegisterState = {
    list: [],
    selected: null,

    form: initialFormState,

    loading: false,

    dropdown: [],

    showCreateModal: false,
    showEditModal: false,
    showViewModal: false
};

const cashRegisterSlice = createSlice({
    name: "cashRegister",
    initialState,
    reducers: {

        /**
         * 🔽 Dropdown de terminales POS
         */
        setCashRegisterDropdown(state, action: PayloadAction<any[]>) {
            state.dropdown = action.payload;
        },

        /**
         * 📋 Establece la lista de terminales POS
         */
        setCashRegisters(state, action: PayloadAction<CashRegister[]>) {
            state.list = action.payload;
        },

        /**
         * 🎯 Selecciona una terminal POS
         */
        setSelectedCashRegister(state, action: PayloadAction<CashRegister | null>) {
            state.selected = action.payload;
        },

        /**
         * 🔄 Actualiza el formulario
         */
        setCashRegisterForm(state, action: PayloadAction<CashRegister>) {
            state.form = action.payload;
        },

        /**
         * ✏️ Actualiza un campo del formulario
         */
        updateCashRegisterField(
            state,
            action: PayloadAction<{ field: keyof CashRegister; value: any }>
        ) {
            const { field, value } = action.payload;
            state.form = {
                ...state.form,
                [field]: value
            };
        },

        /**
         * 🧹 Limpia el formulario
         */
        clearCashRegisterForm(state) {
            state.form = initialFormState;
        },

        /**
         * ⏳ Loading global
         */
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },

        /**
         * 🔄 Cambia el estado activo/inactivo de una terminal POS
         */
        toggleCashRegisterStatus(state, action: PayloadAction<number>) {

            const register = state.list.find(r => r.id === action.payload);

            if (register) {
                register.active = !register.active;
            }

        },

        /**
         * ➕ Modal Create
         */
        openCreateModal(state) {
            state.showCreateModal = true;
        },

        closeCreateModal(state) {
            state.showCreateModal = false;
        },

        /**
         * ✏️ Modal Edit
         */
        openEditModal(state) {
            state.showEditModal = true;
        },

        closeEditModal(state) {
            state.showEditModal = false;
        },

        /**
         * 👁️ Modal View
         */
        openViewModal(state) {
            state.showViewModal = true;
        },

        closeViewModal(state) {
            state.showViewModal = false;
        }
    }
});

export const {

    setCashRegisterDropdown,

    setCashRegisters,
    setSelectedCashRegister,

    setCashRegisterForm,
    updateCashRegisterField,
    clearCashRegisterForm,

    setLoading,
    toggleCashRegisterStatus,

    openCreateModal,
    closeCreateModal,

    openEditModal,
    closeEditModal,

    openViewModal,
    closeViewModal

} = cashRegisterSlice.actions;

export default cashRegisterSlice.reducer;